<template>
  <div class="overview-component-container">
    <div class="overview-title-container">
      <span class="overview-component-title">{{ title }}</span>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="sass">
.overview-component-container
  width: calc(25% - 15px)
  border: 1px solid $color-grey
  padding: 16px
.overview-title-container
  display: flex
  flex-direction: column
.overview-component-title
  font-size: 20px
  padding-bottom: 5px
</style>
